import { atom } from 'jotai';
import type { ParsedStreamChatMessage } from '~/components/ui/misc/StreamChat/types';

export type WidgetState = {
  aiButtonClicked: boolean;
  // Add more widget-specific state fields as needed
};

export type DashboardWidgetsState = {
  [widgetId: string]: WidgetState;
};

export type ChatMessagesState = {
  [dashboardId: string]: ParsedStreamChatMessage[];
};

export const dashboardWidgetsAtom = atom<DashboardWidgetsState>({});

export const selectedTickerFilterAtom = atom<string | null>(null);
export const selectedSectorFilterAtom = atom<string[]>([]);

export const latestSnapshotIdAtom = atom<string | null>(null);
// This will be set by the dashboard component when it loads
export const portfolioIdAtom = atom<string | null>(null);
export const portfolioNameAtom = atom<string | null>(null);
export const portfolioCurrencyAtom = atom<string | null>(null);
// This will be set by the dashboard page when it loads
export const currentDashboardIdAtom = atom<string | null>(null);
export const triggerHardRefetchAtom = atom<number>(0);
export const selectWidgetAIAtom = atom<null, [string], void>(
  null,
  (get, set, widgetId) => {
    const prev = get(dashboardWidgetsAtom);

    const prevState = prev[widgetId]?.aiButtonClicked ?? false;

    // toggle selection for this widget, keep others untouched
    set(dashboardWidgetsAtom, {
      ...prev,
      [widgetId]: {
        ...(prev[widgetId] ?? { aiButtonClicked: false }),
        aiButtonClicked: !prevState,
      },
    });
  },
);

// Atom to store chat messages per dashboard ID
// Structure: { [dashboardId: string]: ParsedStreamChatMessage[] }
export const chatMessagesAtom = atom<ChatMessagesState>({});

export type AIReasoningEntry = {
  reason: string;
  aiReasoning?: string | null;
  companyName?: string | null;
};

export const aiReasoningMapAtom = atom<
  Partial<Record<string, AIReasoningEntry>>
>({});

export type AgentChatInjection = {
  id: number;
  ticker: string;
  content: string;
};

export const agentChatInjectionAtom = atom<AgentChatInjection | null>(null);

export const agentChatVisibleAtom = atom(false);

export const agentChatPrefillAtom = atom<string | null>(null);

// Store the current AI reasoning context for follow-up messages
export const agentChatReasoningContextAtom = atom<{
  ticker: string;
  reasoning: string;
} | null>(null);
